import { render, staticRenderFns } from "./bxKbjs.vue?vue&type=template&id=0216ce61"
import script from "./bxKbjs.vue?vue&type=script&lang=js"
export * from "./bxKbjs.vue?vue&type=script&lang=js"
import style0 from "./bxKbjs.vue?vue&type=style&index=0&id=0216ce61&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports